import { useQuery } from "@apollo/client";
import { GetConsumerEngagementForTrace } from "../graphql/queries";
import { useState } from "react";

interface UseConsumerEngagementParams {
    orgId: string;
    traceItemId?: string;
    productId?: string;
}

export function useConsumerEngagement({ orgId,
    traceItemId,
    productId, }: UseConsumerEngagementParams) {
    const [isExpired, setIsExpired] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(true);

    const { data } = useQuery(GetConsumerEngagementForTrace, {
        fetchPolicy: "network-only",
        variables: {
            consumerEngInput: {
                orgId: orgId,
                ...(traceItemId && { traceItemId }),
                ...(productId && { productId }),
            }
        },
        skip: !orgId,
        onCompleted: (data) => {
            const consumnerData = data.getConsumerEngagementForTrace;
            const now = new Date().getTime();
            const endDate = parseInt(consumnerData.endDate) * 1000;
            setIsExpired(!(consumnerData.isActive && !consumnerData.isDeprecated && now < endDate));
            setLoading(false);
        },
        onError: () => {
            setLoading(false);
        }
    })

    const consumerEngagementDetails = data?.getConsumerEngagementForTrace;

    return { consumerEngagementDetails, isExpired, loading }
}